import * as React from "react";
const SvgFiRrSmileBeam = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-smile-beam_svg__a)">
      <path
        fill="#062147"
        d="M10 12a1 1 0 0 1-1-1c0-1.054-.68-2-1-2s-1 .946-1 2a1 1 0 1 1-2 0c0-1.892 1.232-4 3-4s3 2.108 3 4a1 1 0 0 1-1 1m9-1c0-1.892-1.233-4-3-4-1.768 0-3 2.108-3 4a1 1 0 0 0 2 0c0-1.054.68-2 1-2s1 .946 1 2a1 1 0 0 0 2 0m5 1A12.013 12.013 0 0 0 12 0C-3.9.6-3.894 23.4 12 24a12.013 12.013 0 0 0 12-12m-2 0a10.01 10.01 0 0 1-10 10C-1.25 21.5-1.245 2.5 12 2a10.01 10.01 0 0 1 10 10m-4.334 3.746a1 1 0 0 0-1.33-1.493 6.36 6.36 0 0 1-8.67 0 1 1 0 0 0-1.332 1.492A9.45 9.45 0 0 0 12 18a9.45 9.45 0 0 0 5.666-2.254"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-smile-beam_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSmileBeam;
